import React, { useState } from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import AnimatedButtonContact from 'components/atoms/button/Projects/AnimatedButtonContact';
import { cms } from 'assets/cms';

const NavigationWrapper = styled.nav`
  width: 100%;
  height: 100vh;
  position: absolute;
  left: 0;
  top: 0;
  /* background-color: #b7b5b3; */
  background-color: white;
  overflow: hidden;
  scrollbar-width: none;

  ul {
    list-style: none;
    padding: 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    /* align-item: center; */
    height: 100%;
    margin-left: 35px;

    li {
      margin: 20px 0;
    }
  }
`;

const MenuToggleButton = styled.button`
  width: 40px;
  height: 40px;
  z-index: 9999;
  position: absolute;
  top: 20px;
  right: 20px;
  overflow-x: hidden;
  background-color: white;
  border: 2px solid black;
  @media ${({ theme }) => theme.media.laptop} {
    display: none;
  }

  span:first-child {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    right: 0;
    transform: translateX(
      ${({ isOpen }) => (isOpen ? 'calc(-100% - 2px)' : 0)}
    );
    transition: transform ease-in-out 0.3s;

    &::before,
    &::after {
      position: absolute;
      content: '';
      width: 17px;
      height: 3px;
      background-color: black;
      left: 50%;
    }
    &::before {
      top: 13px;
      transform: translate(-50%, -50%) rotate(-45deg);
    }
    &::after {
      bottom: 13px;
      transform: translate(-50%, 50%) rotate(45deg);
    }
  }
  span:last-child {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: calc(100% + 2px);
    transform: translateX(
      ${({ isOpen }) => (isOpen ? 'calc(-100% - 2px)' : 0)}
    );
    transition: transform ease-in-out 0.3s;

    &::before,
    &::after {
      position: absolute;
      content: '';
      width: 25px;
      height: 3px;
      background-color: black;
      top: 50%;
      left: 50%;
    }

    &::before {
      transform: translate(-50%, -50%) rotate(45deg);
    }

    &::after {
      transform: translate(-50%, -50%) rotate(-45deg);
    }
  }
`;

const SidebarButton = styled.button`
  height: 48px;
  width: 202px;

  text-decoration: none;
  color: white;
  cursor: pointer;
  color: black;
  font-size: 17px;
  /* margin-top: 20px; */
  border: 1px solid white;
  border-radius: 5px;
  cursor: pointer;
  text-decoration: none;
  background-color: none;
`;

const StyledLink = styled(Link)`
  text-decoration: none;
  color: white;
  cursor: pointer;
  color: black;
  font-size: 17px;
  width 100%: ;
  &:hover {
    text-decoration: underline;
  }
  &:visited {
    color: black;
    /* color: white; */
  }
`;
const ImgWrapper = styled.div`
  position: fixed;
  top: 18px;
  left: 26px;
  img {
    height: 40px;
    /* marign: -4px 0 0 5px; */
  }
`;

const CenterWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 30%;
`;

const Sidebar = () => {
  const [isOpen, setisOpen] = useState(false);

  return (
    <>
      <MenuToggleButton
        isOpen={isOpen}
        onClick={() => setisOpen((prevState) => !prevState)}
      >
        <span />
        <span />
      </MenuToggleButton>
      {isOpen ? (
        <NavigationWrapper>
          <ImgWrapper>
            <img src={cms.logo.proj} />
          </ImgWrapper>
          <CenterWrapper>
            <ul>
              <li>
                <Link to="/">
                  <SidebarButton>
                    <StyledLink
                      onClick={() => setisOpen((prevState) => !prevState)}
                      to="/"
                    >
                      O nas
                    </StyledLink>
                  </SidebarButton>
                </Link>
              </li>
              <li>
                <Link to="/elgreen-projekt">
                  <SidebarButton>
                    <StyledLink
                      onClick={() => setisOpen((prevState) => !prevState)}
                      to="/elgreen-projekt"
                    >
                      Projektowanie
                    </StyledLink>
                  </SidebarButton>
                </Link>
              </li>
              <li>
                <Link to="/elgreen-electromobility"></Link>
                <SidebarButton>
                  <StyledLink
                    onClick={() => setisOpen((prevState) => !prevState)}
                    to="/elgreen-electromobility"
                  >
                    Elektromobilność
                  </StyledLink>
                </SidebarButton>
              </li>
              <li>
                <Link to="/elgreen-oze">
                  <SidebarButton>
                    <StyledLink
                      onClick={() => setisOpen((prevState) => !prevState)}
                      to="/elgreen-oze"
                    >
                      OZE
                    </StyledLink>
                  </SidebarButton>
                </Link>
              </li>
              <li>
                <Link to="/kontakt">
                  <SidebarButton>
                    <StyledLink
                      onClick={() => setisOpen((prevState) => !prevState)}
                      to="/kontakt"
                    >
                      Kontakt
                    </StyledLink>
                  </SidebarButton>
                </Link>
              </li>
            </ul>
          </CenterWrapper>
        </NavigationWrapper>
      ) : null}
    </>
  );
};

export default Sidebar;
